import { render, staticRenderFns } from "./TTLoading.vue?vue&type=template&id=113b0142&scoped=true&"
import script from "./TTLoading.vue?vue&type=script&lang=ts&"
export * from "./TTLoading.vue?vue&type=script&lang=ts&"
import style0 from "./TTLoading.vue?vue&type=style&index=0&id=113b0142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b0142",
  null
  
)

export default component.exports